import React from "react";

import { useCurrentChatContext } from "@editor/contexts/CurrentChatContext";

import { useChatSidebar } from "@/features/react-editor/hooks/useChatSidebar";
import IconButton from "@replo/design-system/components/button/IconButton";
import { PanelLeft } from "lucide-react";

function ChatHeader({ showTitle = true }: { showTitle?: boolean }) {
  const { chat, isGeneratingTitle } = useCurrentChatContext();
  const { open: isChatSidebarOpen, toggle: toggleChatSidebar } =
    useChatSidebar();

  let content;
  if (isGeneratingTitle) {
    content = (
      <div className="flex items-center gap-2 text-base font-medium">
        <span
          className="text-muted"
          style={{ animation: "pulse 1.5s ease-in-out infinite" }}
        >
          Generating title...
        </span>
      </div>
    );
  } else if (showTitle) {
    content = (
      <div className="text-base font-semibold">{chat?.title ?? "New Chat"}</div>
    );
  }

  return (
    <div className="relative w-full">
      <div className="absolute z-5 flex flex-row items-center gap-3 pl-1.5 md:pl-0">
        <IconButton
          icon={<PanelLeft size={16} />}
          variant="secondary"
          layoutClassName="hidden md:flex"
          onClick={toggleChatSidebar}
          tooltipText={isChatSidebarOpen ? "Close sidebar" : "Open sidebar"}
        />
        {content}
      </div>
    </div>
  );
}

export default ChatHeader;
